import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import { PhListChecks, PhNotebook } from 'ember-phosphor-icons';
import ExploreCard from 'tio-employee/components/dashboard-kit/explore-card';
import type { WidgetComponentSignature } from 'tio-employee/utils/partner-dashboard/registry';

/** Exploration cards for approvers: the full queue and the program rules they decide against. */
const ApproverGuideWidget: TOC<WidgetComponentSignature<null>> = <template>
  <div class="grid grid-cols-1 gap-4 md:grid-cols-2" data-test-partner-dashboard-approver-guide>
    <ExploreCard
      @title={{t "partner_dashboard.guide.queue_title"}}
      @description={{t "partner_dashboard.guide.queue_description"}}
      @incentive={{t "partner_dashboard.guide.queue_incentive"}}
      @icon={{PhListChecks}}
      @route="authenticated.admin.tas.approval-queue"
    />
    <ExploreCard
      @title={{t "partner_dashboard.guide.programs_title"}}
      @description={{t "partner_dashboard.guide.programs_description"}}
      @incentive={{t "partner_dashboard.guide.programs_incentive"}}
      @icon={{PhNotebook}}
      @route="authenticated.admin.tuition-assistance.index"
    />
  </div>
</template>;

export default ApproverGuideWidget;
